// @packages
import { makeStyles } from '@rneui/themed';
import Constants from 'expo-constants';

export default makeStyles(() => ({
  container: {
    paddingTop: Constants.statusBarHeight,
    flex: 1
  },
  image: {
    resizeMode: 'contain',
    height: 120,
    alignSelf: 'center',
    width: '40%',
    borderTopWidth: 20,
    borderBottomWidth: 20,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent'
  },
  logoutItem: {
    marginHorizontal: 20,
    padding: 3,
    position: 'absolute',
    right: -5,
    top: 40
  },
  backButton: {
    marginHorizontal: 20,
    padding: 3,
    borderWidth: 1,
    borderRadius: 100,
    position: 'absolute',
    left: -5,
    top: 40
  }
}));
